<template>
	<div>
		<el-dialog title="服务详情" :visible.sync="show" width="30%">
			<xiyiDet :row="row"></xiyiDet>
			<el-divider></el-divider>
			<div v-if="row.status">
				<h3 style="margin-bottom: 10px;">客服处理</h3>
				<div>处理人 ：{{row.approvalName}}</div>
				<div style="margin:  10px 0;">处理时间 ：{{setTime(row.approvalTime)}}</div>
				<div>处理状态 ：{{row.status}}</div>
			</div>
			<el-divider></el-divider>
			<div v-if="row.status=='已同意'&&row.flag!=4">
				<h3 style="margin: 10px 0;">派单</h3>
				<el-select  v-model="user"  placeholder="选择工人" clearable="clearable">
					<el-option  v-for="item in users" :label="item.userName " :value="item.userId"></el-option>
				</el-select>
			</div>
			<span v-if="row.status=='已同意'&&row.flag!=4" slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="yes">确 定</el-button>
			</span>
			<div v-if="row.status=='已同意'&&row.flag==4">
				<h3 style="margin: 10px 0;">已完成派单</h3>
				<div>被派单人员:{{row.dispatchName}}</div>
				<div>派单时间:{{setTime(row.dispatchTime)}}</div>
			</div>
			<el-input v-if="!row.status" type="textArea" placeholder="如果拒绝,请填写拒绝原因" v-model="reason"></el-input>
			<span v-if="!row.status" slot="footer" class="dialog-footer">
				<el-button type="primary" @click="ok(1)">同 意</el-button>
				<el-button @click="ok(0)">拒 绝</el-button>
			</span> 
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<el-form-item label="申请人">
				<el-input v-model="form.username" placeholder="申请人" clearable=""></el-input>
			</el-form-item>
			<el-form-item label="处理状态">
				<el-select v-model="form.status" placeholder="处理状态" clearable="clearable">
					<el-option label="已同意" value="已同意"></el-option>
					<el-option label="已拒绝" value="已拒绝"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="username" label="申请人"></el-table-column>
			<el-table-column prop="roomNumber" label="房间号"></el-table-column>
			<el-table-column prop="phone" label="联系电话"></el-table-column>
		<!-- 	<el-table-column prop="projectName" label="服务项目"></el-table-column> -->
		<!-- 	<el-table-column prop="price" label="服务价格(元)"></el-table-column> -->
			<el-table-column prop="createTime" label="申请时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
			</el-table-column>
			<el-table-column prop="leaveMessage" label="备注"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum">
		</el-pagination>
	</div>
</template>

<script>
	import xiyiDet from "./xiyiDet.vue"
	export default {
		components:{
			xiyiDet
		},
		data() {
			return {
				roleId: sessionStorage.roleId,
				user: "", //派单选择的工人
				users: [],
				show: false,
				data: [],
				reason:null,
				row: {},
				form: {
					result: "未完成",
					status: "", //
					username: "",
					currentPage: 1,
					pageSize: 10,
				    type:'洗衣'
				},
				totalNum: 0
			}
		},
		methods: {
			getId(val){
				console.log(val)
			},
			yes() {
				console.log(this.user)
				if(this.user==""){
					this.$message.warning("请选择保洁")
					return
				}
				this.show = false
				this.$http.post(`/api/bdServiceApply/dispatch`, {
					dispatch: this.user,
					processId: this.row.processId,
					id: this.row.id
				}).then(res => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message)
						this.getAll()
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			ok(type) {
				this.show = false
				this.$http.post(`/api/bdServiceApply/ApprovalServiceApply`, {
					id: this.row.id,
					result: type ? "已同意" : "已拒绝",
					processId: this.row.processId,
					agree: type == 1,
					reason:this.reason
				}).then(res => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message)
						this.getAll()
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			handleCurrentChange(val) {
				this.form.currentPage = val
				this.getAll()
			},
			handleSizeChange(val) {
				this.form.pageSize = val
				this.getAll()
			},
			getRow(row) {
				console.log(row)
				// row.showPathList=JSON.parse(row.showPathList)
				this.row = row
				this.show = true
			},
			getAll() {
				this.$http.post(`/api/bdServiceApply/queryServiceApply`, this.form).then(r => {
					if (r.data.data != null) {
						this.data = r.data.data.items
						this.totalNum = r.data.data.totalNum
					} else {
						this.data = null
						this.totalNum = 0
					}
					
					
				})
			},
			getUsers() {
				this.$http.get(`/api/bdServiceApply/getDispatch`).then(r => {
					this.users = r.data.data
				})

			}
		},
		mounted() {
			this.getAll()
			this.getUsers()
		}
	}
</script>

<style>
</style>
